const normalizeBase = (value) => {
  if (!value) {
    return "/api";
  }
  return value.endsWith("/") ? value.slice(0, -1) : value;
};

export const API_BASE = normalizeBase(process.env.REACT_APP_API_BASE || "/api");
export const COURSES_COLLECTION =
  process.env.REACT_APP_COURSES_COLLECTION || "courses";
export const WHATSAPP_PHONE =
  process.env.REACT_APP_WHATSAPP_PHONE || "51915151528";
export const DEFAULT_GTM_ID = process.env.REACT_APP_GTM_ID || "";
export const DEFAULT_GA4_ID = process.env.REACT_APP_GA4_ID || "";
export const DEFAULT_ANALYTICS_MODE =
  process.env.REACT_APP_ANALYTICS_MODE || "";
